import Controller from "@ember/controller";

export default class PreferencesController extends Controller {}
